import * as React from "react";
import { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { sendQueued } from "../../data/library";
import useOnline from "../../hooks/useOnline";
import { useSwipeBack } from "../../hooks/useSwipeBack";
import { Loader } from "../ui/Loader";
import BottomNav from "./BottomNav";
import BrowsePalette from "./BrowsePalette";
import Footer from "./Footer";
import Header from "./Header";
import ToastHost from "./ToastHost";

const Layout: React.FC<{}> = () => {
  const online = useOnline();
  const swipeBack = useSwipeBack();
  const [browsing, setBrowsing] = useState(false);

  // Replay any offline-queued shelf mutations on mount and whenever
  // connectivity returns (ADR 0005 offline tolerance).
  useEffect(() => {
    if (online) void sendQueued();
  }, [online]);

  // ⌘K (Ctrl+K elsewhere) opens Browse's palette from any page, and
  // closes it again.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setBrowsing((open) => !open);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      {!online && (
        <output className="offline-banner">
          You're offline — changes are saved and will sync when you're back.
        </output>
      )}
      <main id="main" {...swipeBack}>
        <Suspense fallback={<Loader block />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <BottomNav />
      <ToastHost />
      {browsing && <BrowsePalette onClose={() => setBrowsing(false)} />}
    </>
  );
};

export default Layout;
